module.exports = "/_next/static/images/shield-duotone-c7ef9e98f8a29e8d73e21e2e825165e0.svg";